<template>
    <div class="container">
        <div>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item
                    :to="{ path: $myRouter.getPreviousRoute().path, params: $myRouter.getPreviousRoute().params }">返回列表</el-breadcrumb-item>
                <el-breadcrumb-item>原始记录页面</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-button type="primary" plain text size="small" class="check-button">提交审核</el-button>

        <el-tabs v-model="activeTab">
            <el-tab-pane label="首页" name="zg_index">
            </el-tab-pane>
            <el-tab-pane label="工程概况" name="zg_gcgk">
            </el-tab-pane>
            <el-tab-pane label="整改建议" name="zg_zgjy">
            </el-tab-pane>
            <el-tab-pane label="直观原始记录" name="zg_record">
            </el-tab-pane>
            <el-tab-pane label="CMA红外1" name="cma_hw1">
            </el-tab-pane>
            <el-tab-pane label="CMA红外2" name="cma_hw2">
            </el-tab-pane>
            <el-tab-pane label="CMA接地电阻" name="cma_jddz">
            </el-tab-pane>
            <el-tab-pane label="CMA剩余电流" name="cma_sydl">
            </el-tab-pane>
            <el-tab-pane label="CMA电气距离" name="cma_dqjl">
            </el-tab-pane>
            <el-tab-pane label="CMA绝缘电阻" name="cma_jydz">
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeTab: 'zg_index'
        }
    },
    methods: {

    },
    created() {
        this.project_id = this.$route.params.project_id;
        this.site_id = this.$route.params.site_id;
    }
}
</script>
<style scoped>
.check-button {
    position: absolute;
    margin-right: 10px;
    right: 0;
    top: 1;
}
</style>